<template>
  <div class="p-3">
    <div
      class="d-flex marker-info-container"
      v-if="data && Object.keys(data).length"
    >
      <div class="col-12 col-md-8 p-0 mt-4 mt-md-0">
        <p v-if="data.clinic_name" class="mb-3">
          <b>({{ data.clinic_name }})</b>
        </p>
        <span>
          <p v-if="data.name" class="mb-2">
            <strong>Name:</strong> {{ data.name }}
          </p>
          <p v-if="data.email" class="mb-2" style="word-break: break-all">
            <strong>Email:</strong> {{ data.email }}
          </p>
          <p v-if="data.type" class="mb-2">
            <strong>Type:</strong> {{ data.type }}
          </p>
        </span>
        <p v-if="data.services.length" class="mb-2 mt-3">
          <strong>Specialt{{ data.services.length > 1 ? "ies" : "y" }}:</strong>
        </p>
        <span v-for="service in data.services" :key="service.id">
          <p class="mb-1">
            {{ service.name }}
          </p>
        </span>
      </div>
      <div class="col-12 col-md-4 p-0 text-center">
        <img
          :src="data.logoUrl"
          v-if="data.logoUrl"
          class="w-100 radius-50 cursor-pointer vendor-img"
        />
        <button
          :disabled="!data.street || !data.street.trim()"
          class="btn btn-sm btn-success mt-2 w-100"
          @click="getLocation(location)"
        >
          Get Directions
        </button>
        <button
          class="btn btn-sm btn-primary mt-2 w-100"
          @click="showCard(true)"
        >
          View Vendor Card
        </button>
        <button
          v-if="data.booking_link"
          class="btn btn-sm btn-outline-dark mt-2 w-100"
          @click="openBooking(data.booking_link)"
        >
          Book an Appointment
        </button>
        <button
          v-if="data.connectText"
          class="btn btn-sm btn-outline-primary mt-2 w-100"
          @click="connectVendor(data, location)"
        >
          {{ data.connectText }}
        </button>
        <button
          v-if="data.locations.length > 1"
          class="btn btn-sm btn-secondary mt-2 w-100"
          @click="showOtherLocations(data, false, true)"
        >
          Another Location
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "MarkerModal",
  props: {
    data: {},
    location: {},
    getLocation: Function,
    connectVendor: Function,
    showCard: Function,
    showOtherLocations: Function,
    openBooking: Function,
  },
};
</script>
<style scoped>
.radius-50 {
  border: 2px solid #efefef;
  border-radius: 50%;
}
</style>
<style lang="scss">
.gm-style {
  .marker-info-container {
    @media (max-width: 767px) {
      flex-direction: column-reverse;
    }
  }
  .vendor-img {
    max-width: 80%;
    @media (max-width: 767px) {
      max-width: 40%;
    }
  }
  .gm-style-iw-d {
    margin-top: 12px;
    max-height: 278px !important;
    @media (max-width: 767px) {
      max-height: 39vh !important;
    }
  }
  .gm-style-iw-c {
    min-width: 430px !important;
    @media (max-width: 430px) {
      min-width: 300px !important;
      padding-left: 0;
      padding-right: 0;
    }
  }
  .gm-style-iw-t {
    right: 0 !important;
    bottom: -50px !important;
    &::after {
      content: none;
    }
  }
  .gm-ui-hover-effect {
    top: 4px !important;
    right: 4px !important;
    width: auto !important;
    height: auto !important;
    img {
      width: 20px !important;
      height: 20px !important;
    }
  }
}
</style>
